<template>
  <div
    class="search-product-personalized"
    role="region"
    aria-describedby="search-product"
  >
    <h2 class="search-product-personalized-label">{{ searchBlockLabel }}</h2>
    <ul v-if="results.length > 0" class="products">
      <li
        v-for="product in results.slice(0, 6)"
        :key="product.id"
        :data-product-id="product.product_id"
      >
        <nuxt-link :to="product.url" @click="hideSearch()">
          <span class="image">
            <picture>
              <source
                :srcset="product.bottle_image_optimized_url"
                type="image/webp"
              />
              <source :srcset="product.bottle_image_url" type="image/jpeg" />
              <img
                :src="product.bottle_image_url"
                alt="Bottle Image"
                height="220"
              />
            </picture>
          </span>
          <span class="name">{{ product.title }}</span>
          <span class="points">{{ maxpoints(product) }}</span>
          <span class="price">${{ product.price_excl_tax }}</span>
        </nuxt-link>
      </li>
    </ul>
    <ul v-else class="products">
      <li v-if="loadingFlag">{{ loadingLabel }}</li>
      <li v-else>{{ noResultsLabel }}</li>
    </ul>
    <nuxt-link class="view-all" to="#" @click.prevent="clickLink"
      >{{ shopAllLabel }}
    </nuxt-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SearchResults',
  props: {
    hideSearch: {
      type: Function,
      required: true,
    },
    noResultsLabel: {
      type: String,
      required: false,
      default: 'No Results',
    },
    results: {
      type: Array,
      required: true,
    },
    searchBlockLabel: {
      type: String,
      required: false,
      default: 'Product',
    },
    shopAllLabel: {
      type: String,
      required: false,
      default: 'Shop All',
    },
    shopAllLink: {
      type: String,
      required: true,
    },
    query: {
      type: String,
      required: false,
      default: '',
    },
    fixedParams: {
      type: String,
      required: false,
      default: '',
    },
    loadingFlag: {
      type: Boolean,
      required: false,
      default: false,
    },
    loadingLabel: {
      type: String,
      required: false,
      default: 'Searching ...',
    },
  },
  computed: {
    ...mapGetters(['getStoreSearchUrl']),
  },
  methods: {
    clickLink() {
      // Must call getStoreSearchUrl() before hideSearch clears vuex search state
      const storeSearchUrl = this.getStoreSearchUrl(
        this.query,
        this.fixedParams,
      )
      this.hideSearch()
      if (this.query.length > 0) {
        this.$router.push(storeSearchUrl)
        return
      }
      this.$router.push(this.shopAllLink)
    },
    maxpoints(product) {
      if (product.expert_reviews) {
        const points = product.expert_reviews.reduce(
          (max, element) => {
            return element.points > max.points ? element : max
          },
          { points: false },
        ).points
        return points ? points + ' Points' : ''
      }
      return ''
    },
  },
}
</script>
